"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.miniCartAddCreator = void 0;
var util_1 = require("./util");
var miniCartAddCreator = function (event) {
    return (0, util_1.addToCartCartEvent)(event, util_1.AddToCartEventNames.MiniCartAdd);
};
exports.miniCartAddCreator = miniCartAddCreator;
